<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
//https://tumaomao.miaodonglvxing.com/travelwalkman/order/smallMap/index.html?title=%E6%B8%85%E5%8D%8E%E5%A4%A7%E5%AD%A6&uuid=13b7ce6e4f89492dbdaf2076db026ba4&userid=83857&randomStr=&v=1686389150092
//https://tumaomao.miaodonglvxing.com/travelwalkman/order/smallMap/index.html?title=%E6%95%85%E5%AE%AB%E5%8D%9A%E7%89%A9%E9%99%A2&uuid=c0ba1ab7e9104b288859389fe6d774ba&userid=83857&randomStr=&v=1681641353835
//?title=%E5%8D%83%E5%B2%9B%E6%B9%96&uuid=b18bc75265364766bb8f08996dab6284&userid=83857&randomStr=&v=1655649635799
//?title=%E7%8E%89%E6%B8%8A%E6%BD%AD%E5%85%AC%E5%9B%AD&uuid=aee0e35270e04e098a55868ec2dbeb22&userid=83857&randomStr=&v=1659236670056
//https://tumaomao.miaodonglvxing.com/travelwalkman/order/smallMap/index.html?title=%E6%95%85%E5%AE%AB%E5%8D%9A%E7%89%A9%E9%99%A2&uuid=c0ba1ab7e9104b288859389fe6d774ba&userid=83857&randomStr=&v=1676385502322
export default {
  name: "App",
  created: function() {
    this.$http
      .get(
        "https://www.tmm6.cn/travelwalkman/order/douYinGetSign?url=" +
          encodeURIComponent(location.href.split("#")[0])
      )
      .then(data => {
        // wx.config({
        //   debug: false,
        //   appId: data.appId,
        //   timestamp: data.timestamp,
        //   nonceStr: data.noncestr,
        //   signature: data.signature,
        //   jsApiList: [
        //     'checkJsApi',
        //     'showOptionMenu',
        //     'hideOptionMenu',
        //     'hideMenuItems',
        //     'closeWindow',
        //     'onMenuShareTimeline',
        //     'onMenuShareAppMessage',
        //     'chooseImage',
        //     'uploadImage',
        //     'downloadImage',
        //     'getLocalImgData',
        //     'getLocation',
        //     "hideMenuItems",
        //     "invoke",
        //   ]
        // });
        const sdk = window.DouyinOpenJSBridge;
        const timestamp = String(parseInt(Date.now() / 1000)); // 类型为 String
        const signature = data.signature; // 生成签名用的随机字符串
        const noncestr = data.noncestr; //
        const url = location.href;
        sdk.config({
          params: {
            client_key: data.noncestr, // clientKey在你的网页应用申请通过后得到
            signature: signature, // 服务端计算的签名，该签名被抖音开放平台验证通过后方可调用jsb方法
            timestamp, // 时间戳
            nonce_str: noncestr,
            url // 为应用申请的 JSB 安全域名下的链接，需要携带协议。e.g. https://jsb.security.domain/page.html
          }
        });
      });
  },
  mounted: function() {
    setTimeout(() => {
      this.isloading = this.$store.state.isLoading = true;
      this.loadingTxt = "";
    }, 10000);
  }
};
</script>

<style>
#app {
  width: 7.5rem;
  height: 100%;
  position: fixed;
  left: 50%;
  top: 0;
  margin-left: -3.75rem;
}
.zIndexClass {
  z-index: -1 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue